import * as React from "react"
import { cn } from "@/lib/utils"

export interface ArrowRightIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 13
   */
  size?: number
}

/**
 * Arrow Right icon as SVG (arrow inside circle)
 *
 * This icon represents forward navigation or action confirmation,
 * commonly used in CTA buttons like "Validate & Pair".
 *
 * @example
 * ```tsx
 * <ArrowRightIcon />
 * <ArrowRightIcon size={16} className="text-white" />
 * ```
 */
export const ArrowRightIcon = React.forwardRef<SVGSVGElement, ArrowRightIconProps>(
  ({ size = 13, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path
          d="M12.2,4.1c-.3-.7-.8-1.4-1.3-2-.6-.6-1.2-1-2-1.3-.7-.3-1.5-.5-2.4-.5s-1.6.2-2.4.5c-.7.3-1.4.8-2,1.3-.6.6-1,1.2-1.3,2-.3.7-.5,1.5-.5,2.4s.2,1.7.5,2.4c.3.7.8,1.4,1.3,2,.6.6,1.2,1,2,1.3.7.3,1.5.5,2.4.5s1.7-.2,2.4-.5c.7-.3,1.4-.8,2-1.3.6-.6,1-1.2,1.3-2,.3-.7.5-1.5.5-2.4s-.2-1.6-.5-2.4ZM10.1,6.7c0,0,0,.1-.1.2l-2.6,2.4c0,0-.2.2-.3.2,0,0-.2,0-.3,0-.1,0-.3,0-.4-.1,0-.1-.1-.2-.1-.4v-1.1h-2.4c-.3,0-.5,0-.6-.2-.2-.1-.2-.4-.2-.6v-1.2c0-.3,0-.5.2-.6.2-.2.4-.2.6-.2h2.4v-1.1c0-.1,0-.3.1-.4.1-.1.2-.2.4-.2s.2,0,.3,0,.2.1.3.2l2.6,2.4c0,0,.1.1.1.2s0,.1,0,.2,0,.1,0,.2Z"
          fill="currentColor"
        />
      </svg>
    )
  }
)

ArrowRightIcon.displayName = "ArrowRightIcon"
